// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2T_D3","errorLogs":"styles_errorLogs__2lbdm"};